// extracted by mini-css-extract-plugin
export default {"main":"Seminar_main__o7v69"};